import { render, staticRenderFns } from "./MessagePreview.vue?vue&type=template&id=d1d23114&scoped=true&"
import script from "./MessagePreview.vue?vue&type=script&lang=js&"
export * from "./MessagePreview.vue?vue&type=script&lang=js&"
import style0 from "./MessagePreview.vue?vue&type=style&index=0&id=d1d23114&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d23114",
  null
  
)

export default component.exports